import styled from 'styled-components'
import { iPadDown, iPadUp } from '../../../styles/mediaQueries'
import { ModalProps } from './ClassicModal'
import theme from '../../../styles/theme'

export const modalBorderRadius = '2.34vw'
export const modalBorderRadiusMobile = '7.25vw'

type SliderModalProps = Pick<ModalProps, 'dolaTheme' | 'visible'>

const SliderModal = styled.div<SliderModalProps>`
  background-color: ${({ dolaTheme }) => theme[dolaTheme].background};
  border-radius: ${modalBorderRadius} 0 0 ${modalBorderRadius};
  height: 100%;
  min-width: 540px;
  width: 42vw;
  overflow: hidden;
  position: fixed;
  transition: right 0.4s ease, max-height 0.4s ease;
  z-index: 10001;
  ${({ visible }) =>
    visible
      ? `
      transition-delay: 0.2s;
      box-shadow: -4px 4px 40px #00000040;
    `
      : ''}

  ${iPadUp} {
    right: ${({ visible }) => (visible ? 0 : '-50vw')};
    top: 0;
  }

  ${iPadDown} {
    border-radius: ${modalBorderRadiusMobile} ${modalBorderRadiusMobile} 0 0;
    bottom: 0;
    height: auto;
    left: 0;
    max-height: ${({ visible }) => (visible ? '75vh' : 0)};
    min-width: 100%;
    width: 100%;
  }
`

export default SliderModal
